export default "__VITE_ASSET__zsX1xgQM__"